import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
// api
import { getServicesActives } from 'api/company';
// components
import AutoCompleteInput from './autoCompleteInput';

const SearchService = ({
  filterBy = 'name',
  onSelected,
  placeholder,
  defaultService = null,
  showLabel = '',
}) => {
  const [serviceSelected, setServiceSelected] = useState(null);

  useEffect(() => {
    if (defaultService) {
      setServiceSelected({
        id: defaultService.id,
        name: defaultService.name,
        image: defaultService.image,
      });
    } else {
      setServiceSelected(null);
    }
  }, [defaultService]);

  const onSearch = async (value) => {
    if (value.length > 1) {
      const { status, data } = await getServicesActives({
        [filterBy]: value
      });
      const results = Array.isArray(data) ? data : data?.results || [];
      if (status === 200 && results.length > 0) {
        return results.map(({ id, name, image }) => ({
          id,
          name,
          image,
          value: name,
          label: name, 
        }));
      }
    }
    return [];
  };

  return (
    <AutoCompleteInput
      label={showLabel}
      defaultOptions={serviceSelected ? [{ ...serviceSelected, label: serviceSelected.name }] : []}
      defaultValue={null} 
      onSelect={(selected) => {
        setServiceSelected(selected);
        onSelected(selected);
      }}
      onSearch={onSearch}
      placeholder={placeholder}
      showSearch={true}
    />
  );
};

SearchService.propTypes = {
  filterBy: PropTypes.string,
  placeholder: PropTypes.string,
  onSelected: PropTypes.func.isRequired,
  defaultService: PropTypes.object,
  showLabel: PropTypes.string,
};

export default SearchService;